/**
 * Map of all Contentful marks.
 */
export default {
  BOLD: 'bold',
  ITALIC: 'italic',
  UNDERLINE: 'underline',
  CODE: 'code',
};



// WEBPACK FOOTER //
// ../../rich-text-types/src/marks.ts